export const AccountingSolicitationsStatus = {
  em_aberto: "Em aberto",
  respondido_pela_contabilidade: "Respondido pela contabilidade",
  respondido_pelo_cliente: "Respondido pelo cliente",
  finalizado: "Finalizado",
  cancelado: "Cancelado",
}